import { useTranslation } from 'react-i18next';

import { TreeFormField } from 'core/components';
import { useFormContext } from 'core/states';
import { useGetTaxonomyGroup, useGetTaxonomyGroups } from 'taxonomy/hooks';
import { taxonomyService } from 'taxonomy/services';

interface IProps {
  name: string;
}

export const TaxonomyGroupFormField = ({ name }: IProps) => {
  const { t } = useTranslation();
  const { watch } = useFormContext();

  const selectedItem = watch(name);
  const selectedId = selectedItem?.id;

  const { record: selectedItemData, isLoading: selectedItemLoading } = useGetTaxonomyGroup(
    { id: selectedId },
    !!selectedId
  );

  const childFilter = selectedId
    ? { filters: { parentId: selectedId } }
    : { filters: { level: 1 } };

  const { records: childItems = [], isLoading: childItemsLoading } =
    useGetTaxonomyGroups(childFilter);

  return (
    <TreeFormField
      name={name}
      placeholder={t('labelCategory')}
      allItemsLabel={t('labelAllCategories')}
      getOptions={taxonomyService.getTaxonomyGroups}
      isLoading={selectedItemLoading || childItemsLoading}
      selectedItem={selectedItemData}
      childItems={childItems}
    />
  );
};
